import React from 'react';
import FAQHero from './FAQHero';
import FAQSection from './FAQSection';
import Footer from '../../components/Footer';

const FAQ = () => {
  return (
    <div className="faq-page">
      <FAQHero />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default FAQ; 